<template>
  <InfoCard
    class="education-info"
    icon="iconfont iconbianzu"
    :title="$t(`${i18nPrefix}.title.education`)"
    :infoList="educationList"
    :infoLines="infoLines"
  ></InfoCard>
</template>

<script>
import _ from 'lodash'
import InfoCard from '@/components/candidate/infoCard.vue'
import moment from 'moment'
import { addI18nProperty, getConstantI18nValue } from '@/i18n'
import { DEGREE } from '@/constant/meta'
import { ACADEMIC_RATING } from '@/constant/application'

export default {
  components: {
    InfoCard
  },
  props: {
    educations: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate'
    }
  },
  computed: {
    infoLines () {
      const i18nPrefix = this.i18nPrefix
      const lines = {
        institution: {
          labelI18nKey: `${i18nPrefix}.label.school`,
          dataKey: 'schoolI18nName'
        },
        degreeAndMajor: {
          labelI18nKey: `${i18nPrefix}.label.degreeAndMajor`,
          formatter: (val, info) => {
            const degree = info.degree_level ? getConstantI18nValue(DEGREE, info.degree_level, 'meta.DEGREE') : ''
            return _.filter([degree, info.majorI18nName]).join(', ')
          }
        },
        date: {
          labelI18nKey: `${i18nPrefix}.label.date`,
          formatter: (val, info) => {
            if (!info.start_date && !info.end_date) {
              return '-'
            }
            const startDate = info.start_date ? moment(info.start_date).format('YYYY.MM.DD') : ''
            const endDate = info.end_date ? moment(info.end_date).format('YYYY.MM.DD') : this.$t(`${i18nPrefix}.label.now`)
            return _.join([startDate, endDate], ' - ').trim()
          }
        },
        gpa: {
          labelI18nKey: `${i18nPrefix}.label.gpa`
        },
        academicRating: {
          labelI18nKey: `${i18nPrefix}.label.academicRating`,
          formatter: (val, info) => {
            return info.academic_rating && getConstantI18nValue(ACADEMIC_RATING, info.academic_rating, `${this.i18nPrefix}.ACADEMIC_RATING`)
          }
        },
        summary: {
          labelI18nKey: `${i18nPrefix}.label.summary`,
          multipleText: true,
          fullLine: true
        }
      }
      return lines
    },
    educationList () {
      return _.map(this.educations, item => {
        addI18nProperty(item, 'schoolI18nName', 'cn_name', 'name', item.school)
        addI18nProperty(item, 'majorI18nName', 'cn_name', 'name', item.major)
        return item
      })
    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.education-info {
  ::v-deep {
    .card-title-container {
      .title-icon {
        display: inline-block;
        width: 26px;
        line-height: 26px;
        border-radius: 50%;
        background: #9a999b;
        color: #ffffff;
        font-size: 16px;
        text-align: center;

        &::before {
          display: inline-block;
          margin-left: -2px;
        }
      }
    }
  }
}
</style>
